import {isEmpty} from 'lodash';
import queryString from 'query-string';
import {createSelector} from 'reselect';
import {RootState} from 'src/js/store';

import {FetcherUtils} from './fetcher_utils';

export const ROUTE_ROOT = '/';
export function getIsLinkActive(routePathName: string, routePathIsPrefix: boolean | undefined, currentPath: string, indexPathName: string) {
  // trim
  const queryIndex = currentPath.indexOf('?');
  const currentPathName = queryIndex > -1 ? currentPath.substring(0, queryIndex) : currentPath;
  // match
  const indexMatches = currentPathName === ROUTE_ROOT && routePathName === indexPathName;
  const routeMatches = routePathIsPrefix ? currentPathName.startsWith(routePathName) : currentPathName === routePathName;
  return indexMatches || routeMatches;
}

export const getSearchString = (indexPath: string, pathName: string, queryParameters: Record<string, any>) => {
  // add global parameters
  // a try to remove "global parameters"
  let queryWithGlobalParameters = /* queryParameters[GLOBAL_PARAMETERS_PATH] || */ {};

  // add path-specific parameters
  queryWithGlobalParameters = {
    ...(pathName === indexPath && isEmpty(queryParameters[pathName]) ? queryParameters[ROUTE_ROOT] : queryParameters[pathName]),
    ...queryWithGlobalParameters,
  };
  return FetcherUtils.transformJSONToUrlEncodedParams(queryWithGlobalParameters);
};

const getRouterLocation = (state: RootState) => state.router.location;

export const getRouterLocationPathname = createSelector([getRouterLocation], (routerLocation) => routerLocation?.pathname);

export const getRouterLocationQuery = createSelector([getRouterLocation], (routerLocation) =>
  queryString.parse(routerLocation?.search ?? '')
);
